module.exports = __webpack_public_path__ + "static/media/TWI CAROUSEL 01.faed2451.jpg";